<template>
  <v-card
    class="mx-auto info-card"
    flat
  >
    <v-toolbar short flat>
      <v-toolbar-title>
        <v-icon>mdi-hexagon-multiple-outline</v-icon>
        {{ lang.config.themes.info.generic_theme.name }}
      </v-toolbar-title>
    </v-toolbar>
    <div class="info-card-content">
      <v-img
        :src="require('../../../../themes/' + lang.config.themes.info.generic_theme.path + '/thumb.png')"
        :lazy-src="require('../../../../themes/' + lang.config.themes.info.generic_theme.path + '/thumb.png')"
        height="250"
      ></v-img>
      <!-- DIVISAO -->
      <v-subheader class="font-weight-regular mt-1 mx-1">
        {{ lang.config.themes.info.description }}
      </v-subheader>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.themes.info.name }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>{{ lang.config.themes.info.generic_theme.name }}</div>
        </v-card-text>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.themes.info.developer }}
        </v-card-subtitle>
        <v-card-text class="text--primary font-weight-light pt-0 pb-1">
          <div>
            <a
              :href="lang.config.themes.info.generic_theme.website"
              target="_blank"
            >
              {{ lang.config.themes.info.generic_theme.developer }}
            </a>
          </div>
        </v-card-text>
      </template>
      <template>
        <v-card-subtitle class="pb-0 pt-0">
          {{ lang.config.themes.info.status.title }}
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-progress-circular
                v-on="on"
                :value="100"
                :size="9"
                color="green"
                class="ml-1 server-status"
              ></v-progress-circular>
            </template>
            <span>{{ lang.config.themes.info.status.active }}</span>
          </v-tooltip>
        </v-card-subtitle>
      </template>
    </div>
  </v-card>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ]
}
</script>
